const indexItems = [
  { title: '动作大片', icon: 'ri-sword-line', count: '2,300+', desc: '热血动作片高清合集', color: 'text-red-500' },
  { title: '喜剧天地', icon: 'ri-emotion-laugh-line', count: '1,800+', desc: '爆笑喜剧欢乐不停', color: 'text-orange-500' },
  { title: '科幻世界', icon: 'ri-rocket-line', count: '1,500+', desc: '硬核科幻视觉盛宴', color: 'text-cyan-500' },
  { title: '悬疑剧场', icon: 'ri-search-eye-line', count: '1,200+', desc: '烧脑悬疑全程高能', color: 'text-purple-500' },
  { title: '爱情文艺', icon: 'ri-heart-line', count: '2,100+', desc: '浪漫爱情感动人心', color: 'text-pink-500' },
  { title: '恐怖惊悚', icon: 'ri-ghost-line', count: '900+', desc: '惊险刺激胆量挑战', color: 'text-gray-600' },
  { title: '纪录片库', icon: 'ri-earth-line', count: '1,600+', desc: '真实纪录探索世界', color: 'text-green-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            影视专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型快速浏览，发现你感兴趣的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex flex-col items-center p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-background-100 transition-all duration-200 cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-50 transition-colors`}>
                <i className={`${item.icon} ${item.color} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.title}
              </h3>
              <span className="mt-1 text-xs text-foreground-400">{item.count}部</span>
              <p className="mt-1 text-xs text-foreground-500 hidden sm:block">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}